import { css, useTheme } from '@chakra-ui/react';
import { useMemo } from 'react'; // TODO: remove layerStyle/textStyle workaround
// https://github.com/chakra-ui/chakra-ui/issues/3884

export var useChakraPriorityStyles = _ref => {
  var {
    layerStyle,
    textStyle
  } = _ref;
  var theme = useTheme();
  var styles = {
    layerStyle,
    textStyle
  };
  var finalCss = useMemo(() => css(styles)(theme), [JSON.stringify(styles), theme]);
  return {
    css: finalCss
  };
};
//# sourceMappingURL=useChakraPriorityProps.js.map